import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-test-coming-soon-dialog',
  templateUrl: './test-coming-soon-dialog.component.html',
  styleUrls: ['./test-coming-soon-dialog.component.css']
})
export class TestComingSoonDialogComponent implements OnInit {

    constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TestComingSoonDialogComponent>
  ) {
    dialogRef.disableClose = false;
   }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
